import { render, staticRenderFns } from "./AnalysisTab.vue?vue&type=template&id=60d6ce1b&scoped=true&"
import script from "./AnalysisTab.vue?vue&type=script&lang=js&"
export * from "./AnalysisTab.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisTab.vue?vue&type=style&index=0&id=60d6ce1b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6ce1b",
  null
  
)

export default component.exports